import { CategoryBasicResponse } from '@bluestone-node-sdk/pim';
import sessionApi from '~/clientApis/sessionApi';
import { getStore } from '~/mobx/AppStore';

export const onChangeSLagId = async (id: string) => {
    const { adminStore, companyStore, generalSettingsStore, electionMenuStore } = getStore();
    // Find company with matching ID
    const selectedCompany = companyStore.companyList?.find((company) => company?.id === id) as CategoryBasicResponse;

    const selectedElectionId = '';
    const isSettingsDisabled = false;

    // Update stores
    generalSettingsStore.setSelectedElectionId(selectedElectionId);
    generalSettingsStore.setIsSettingsDisabled(isSettingsDisabled);
    companyStore.setSelectedCompany(selectedCompany);
    companyStore.setSelectedSlagId(id);
    adminStore.fetchElectionAndRegions(id);
    electionMenuStore.setIsCompanyLevel(true);

    // Save to session
    await sessionApi.updateSession({ selectedSlagId: id, isSettingsDisabled, selectedElectionId });
};
